export default __webpack_public_path__ + "static/media/success.6453aeb8.svg";